import type { IAuthProps } from "@tiendeo/auth/dist/Auth";
import type { ICookiesClient } from "@tiendeo/cookies";
import type TiendeoStatsClient from "@tiendeo/js-stats-client";
import type { IConfig } from "config/IConfig";
import type { ITexts } from "translations/ITexts";
import { getStatsData } from "./tiendeoStats";

export const getAuthProps = (
    configs: IConfig,
    texts: ITexts,
    cookiesClient: ICookiesClient,
    tiendeoStatsClient: TiendeoStatsClient,
    searchWord?: string,
): IAuthProps => {
    const { Platform, SearchCity, SearchWord } = getStatsData(
        configs.default_city,
        searchWord || configs.default_search,
    );

    return {
        AuthApiUrl: configs.url_auth_api,
        INTERNAL_API_URL: configs.internal_api_url,
        StatsData: {
            Platform,
            Provider: "",
            City: SearchCity,
            Search: SearchWord,
        },
        Texts: {
            LOGIN_DESCRIPTION: texts.LOGIN_DESCRIPTION,
            LOGIN_FINE_PRINT: texts.LOGIN_FINE_PRINT,
        },
        getCookie: cookiesClient.Get,
        setCookie: cookiesClient.Set,
        sendEvent: tiendeoStatsClient.Event,
    };
};
